import React from 'react';
import { useTranslation } from "react-i18next";

const ContractLifecycle = () => {
  const { t } = useTranslation("translation");

  const steps = [
    {
      title: t("lifecycle.createTitle"),
      desc: t("lifecycle.createDesc"),
      accent: "#a066ff",
      svg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="#a066ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="40" height="40">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
      )
    },
    {
      title: t("lifecycle.draftTitle"),
      desc: t("lifecycle.draftDesc"),
      accent: "#ff725c",
      svg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="#ff725c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="40" height="40">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      )
    },
    {
      title: t("lifecycle.reviewTitle"),
      desc: t("lifecycle.reviewDesc"),
      accent: "#29c6b7",
      svg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="#29c6b7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="40" height="40">
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.35-4.35" />
          <path d="M11 8v6" />
          <path d="M8 11h6" />
        </svg>
      )
    },
    {
      title: t("lifecycle.approveTitle"),
      desc: t("lifecycle.approveDesc"),
      accent: "#46ca6a",
      svg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="#46ca6a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="40" height="40">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      )
    },
    {
      title: t("lifecycle.signTitle"),
      desc: t("lifecycle.signDesc"),
      accent: "#f3b600",
      svg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="#f3b600" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="40" height="40">
          <path d="M3 17h18M3 17v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3" />
          <path d="M5 17V7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10" />
          <path d="m8 12 3 3 5-5" />
        </svg>
      )
    },
    {
      title: t("lifecycle.deliverTitle"),
      desc: t("lifecycle.deliverDesc"),
      accent: "#2e9cff",
      svg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="#2e9cff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="40" height="40">
          <line x1="22" x2="11" y1="2" y2="13" />
          <polygon points="22 2 15 22 11 13 2 9 22 2" />
        </svg>
      )
    },
    {
      title: t("lifecycle.archiveTitle"),
      desc: t("lifecycle.archiveDesc"),
      accent: "#ee5ee6",
      svg: (
        <svg viewBox="0 0 24 24" fill="none" stroke="#ee5ee6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="40" height="40">
          <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
          <line x1="9" x2="15" y1="9" y2="9" />
          <line x1="9" x2="15" y1="15" y2="15" />
        </svg>
      )
    }
  ];

  return (
    <div className="guest-container my-5">
      <div className="text-center">
        <h2 className="cf-title">{t("lifecycle.howItWorks")}</h2>
        <div className="cf-subtitle">{t("lifecycle.subtitle")}</div>
      </div>

      <div className="cf-steps">
        {steps.map((step, i) => (
          <div className="cf-card" key={step.title}>
            <div className="cf-step-label" style={{ color: step.accent }}>
              {t("lifecycle.stepLabel", { number: i + 1 })}
            </div>

            <div className="cf-card-icon">{step.svg}</div>

            <div className="cf-card-title">{step.title}</div>

            <div className="cf-card-desc">{step.desc}</div>

            {i < steps.length - 1 && (
              <svg
                className="cf-arrow"
                width="70"
                height="40"
                viewBox="0 0 70 40"
                fill="none"
              >
                <path
                  d="M5 20 Q35 45 65 20"
                  stroke="#dfdfea"
                  strokeWidth="2"
                  fill="none"
                />
                <polygon points="60,18 66,20 60,22" fill="#dfdfea" />
              </svg>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContractLifecycle;
